import { useEffect, useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

const Partners = () => {
  const partList = [
    {
      one: "/images/part1.png",
      two: "/images/part20.png",
      three: "/images/part9.png",
    },
    {
      one: "/images/part2.png",
      two: "/images/part19.png",
      three: "/images/part10.png",
    },
    {
      one: "/images/part3.png",
      two: "/images/part18.png",
      three: "/images/part11.png",
    },
    {
      one: "/images/part4.png",
      two: "/images/part17.svg",
      three: "/images/part8.svg",
    },
    {
      one: "/images/part5.png",
      two: "/images/part16.png",
      three: "/images/part12.png",
    },
    {
      one: "/images/part6.png",
      two: "/images/part15.png",
      three: "/images/part7.png",
    },
    {
      one: "/images/part7.png",
      two: "/images/part14.png",
      three: "/images/part20.png",
    },
    {
      one: "/images/part8.svg",
      two: "/images/part13.png",
      three: "/images/part3.png",
    },
    {
      one: "/images/part10.png",
      two: "/images/part12.png",
      three: "/images/part16.png",
    },
    {
      one: "/images/part11.png",
      two: "/images/part1.png",
      three: "/images/part5.png",
    },
  ];

  const [count, setCount] = useState(0);

  useEffect(() => {
    if (window.innerWidth >= 768) {
      setCount(8);
    } else {
      setCount(2);
    }

    window.addEventListener("resize", () => {
      if (window.innerWidth >= 768) {
        setCount(8);
      } else {
        setCount(2);
      }
    });
  }, []);

  return (
    <div id="partners" className="relative w-full h-full py-14 lg:py-28">
      <div
        data-aos="fade-up"
        id="title"
        className="relative w-full h-fit px-[calc((100%-var(--container))/2)] flex justify-start items-end gap-2 lg:gap-5 xl:mb-14"
      >
        <div className="relative w-fit h-full mx-auto text-center">
          <img
            className="!relative w-auto h-full max-h-14 lg:max-h-16 2xl:max-h-20 object-contain mx-auto"
            alt="집치워드림센터 로고"
            src="/images/logo.png"
            width={593}
            height={136}
          />
          <p className="text-secondary my-3 lg:text-lg">- PRATNERS -</p>
        </div>
      </div>
      <div className=" relative w-full h-full py-10">
        {count > 0 && (
          <Swiper
            spaceBetween={30}
            centeredSlides={false}
            loop={true}
            slidesPerView={count}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }}
            speed={5000}
            loopAdditionalSlides={1}
            mousewheel={false}
            simulateTouch={false}
            allowTouchMove={false}
            grabCursor={false}
            modules={[Autoplay]}
            className="mySwiper swiper-wrapper relative w-full h-full mb-5"
          >
            {partList.map((v, i) => (
              <SwiperSlide
                key={i}
                className=" relative w-full h-full overflow-hidden"
              >
                <div className="relative w-full h-full border px-3 py-6">
                  <img
                    className="!relative w-auto max-w-20 h-8 lg:max-w-32 lg:h-14 mx-auto object-contain"
                    alt={`집치워드림센터 협력사 로고 ${i * 3 + 1}`}
                    src={v.one}
                    width={500}
                    height={500}
                  />
                </div>
                <div className="relative w-full h-full border px-3 py-6 my-5">
                  <img
                    className="!relative w-auto max-w-20 h-8 lg:max-w-32 lg:h-14 mx-auto object-contain"
                    alt={`집치워드림센터 협력사 로고 ${i * 3 + 2}`}
                    src={v.two}
                    width={500}
                    height={500}
                  />
                </div>
                <div className="relative w-full h-full border px-3 py-6">
                  <img
                    className="!relative w-auto max-w-20 h-8 lg:max-w-32 lg:h-14 mx-auto object-contain"
                    alt={`집치워드림센터 협력사 로고 ${i * 3 + 3}`}
                    src={v.three}
                    width={500}
                    height={500}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </div>
  );
};

export default Partners;
